export default __webpack_public_path__ + "static/media/CaduceusLoginBg.56082aba.jpg";